import { useProposalsEditReviewStore } from "./ProposalsEditReviewStore"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite/dist"
import useInitialMount from "reusable/hooks/useInitialMount"
import ProposalsViewProposal from "../../view/ProposalsViewProposal"
import { useProposalsEditStore } from "../ProposalsEditStore"
import { themeConfig } from '@gap/shared/theme'

export default observer(function ProposalsEditReview() {
   const { goToStep1, goToStep2, goToStep3, goToStep4 } = useProposalsEditStore()
   const proposalsEditReviewStore = useProposalsEditReviewStore()

   useInitialMount(() => {
      proposalsEditReviewStore.initialise()
   })

   if (!proposalsEditReviewStore.formHandler) {
      return undefined
   }

   return <Stack sx={{
      flexGrow: 1,
      alignItems: 'center',
      '& > .MuiStack-root, & > .MuiBox-root > .MuiPaper-root': {
         maxWidth: themeConfig.breakpoints.values.md,
         margin: '0 auto',
         width: '100%',
      }
   }}>
      <Stack sx={{ width: '100%', maxWidth: themeConfig.breakpoints.values.lg, mb: { xs: 4, sm: 8 } }}>
         <Typography variant="h4" sx={{ mb: 2 }}>Review and send</Typography>
         <Typography variant="body1">Check if everything looks right, then send when you're ready.</Typography>
      </Stack>

      <ProposalsViewProposal {...{
         proposal: proposalsEditReviewStore.proposal,
         goToStep1,
         goToStep2,
         goToStep3,
         goToStep4,
      }} editable />
   </Stack>
})
